import { InjectionToken } from '@angular/core';
export var HIGHLIGHT_JS = new InjectionToken('highlight.js');
//# sourceMappingURL=highlightJs.token.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-highlight-js/dist/esm/src/highlightJs.token.js
// module id = ./node_modules/angular-highlight-js/dist/esm/src/highlightJs.token.js
// module chunks = common